import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/store';
import DateSwitch from '../common/DateSwitch';
import SlotItem from './SlotItem';
import './SlotList.css';
import PrintButton from './PrintButton';
import ExportButton from './ExportButton';

const SlotList: FC = () => {
	const { t } = useTranslation();
	const slots = useAppSelector(store => store.slots);
	const [ current, setCurrent ] = useState('');


	return (
		<div>
			<DateSwitch current={current} onChange={setCurrent}/>
			<div className='SlotList'>
				{slots.map(slot => slot.start.startsWith(current) ? <SlotItem key={slot.id} slot={slot}/> : null)}
			</div>
			<div className='p center'>
                <PrintButton/>
                <ExportButton/>
            </div>
			<div className='p'>
				{t('profile.lock')}
			</div>
		</div>
	);
};

export default SlotList;
